const caseStudies = [
  {
    title: 'Transforming Medical Education with Enterprise EHR Training Platform',
    image: '/case_studies/banners/ehr-banner.svg',
    tags: ['Java', 'Spring Boot', 'Angular'],
    link: '/case-studies-academic-ehr',
    alt: 'Academic EHR training platform developed by Techxplore using Java, Spring Boot, and Angular. The solution provides realistic patient scenarios and clinical documentation tools in a secure, simulated environment for medical students and faculty.'
  },
  {
    title: 'Revolutionizing Document Workflows for 2,500+ Global Enterprises',
    image: '/case_studies/banners/document-management-banner.svg',
    tags: ['Java', 'ElasticSearch', 'Docker'],
    link: '/case-studies-document-management',
    alt: 'Document management system developed by Techxplore with Java and Spring Boot, integrated with ElasticSearch for powerful search capabilities and OCR technology for automated document processing.'
  },
  {
    title: 'Empowering Mental Health Care with Digital Innovation',
    image: '/case_studies/banners/mentor-banner.svg',
    tags: ['Java', 'Spring Boot', 'PostgreSQL'],
    link: '/case-studies-mental-health',
    alt: 'Mental health platform developed by Techxplore for psychiatric clinics to digitize consultation and therapy workflows, streamline patient management, track session notes, and enhance teleconsultation efficiency with a secure, clinical-grade application.'
  },
  {
    title: 'Modernizing Banking for 150+ Financial Institutions Worldwide',
    image: '/case_studies/banners/banking-app-banner.svg',
    tags: ['Spring Boot', 'Docker', 'Kubernetes'],
    link: '/case-studies-modern-banking',
    alt: 'Modern banking infrastructure developed by Techxplore using Spring Boot microservices architecture, containerized with Docker and orchestrated with Kubernetes for scalable cloud-native deployment.'
  },
  {
    title: 'Driving ROI Excellence with Real-Time Campaign Intelligence',
    image: '/case_studies/banners/advertising-banner.svg',
    tags: ['Spring Boot', 'Angular', 'AWS'],
    link: '/case-studies-realtime-advertising',
    alt: 'Real-time advertising analytics platform developed by Techxplore using Spring Boot and Angular, with Amazon SQS for asynchronous message processing and Redis for real-time data access.'
  },
  {
    title: 'Powering FIFA World Cup 2022 with Smart Traffic Solutions',
    image: '/case_studies/banners/traffice-data-system-banner.svg',
    tags: ['Spring Boot', 'Angular', 'PostgreSQL'],
    link: '/case-studies-traffic-management',
    alt: 'Traffic Data Management System developed by Techxplore using Spring Boot, Angular, and PostgreSQL, with ArcGIS integration for advanced geospatial visualization and analysis.'
  },
];

export default caseStudies;